import React, { useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import useJumboLayoutSidebar from '@jumbo/hooks/useJumboLayoutSidebar';
import AuthUserDropdown from '../../AuthUserDropdown';
import { FormControl, IconButton, InputLabel, MenuItem, Select, Slide, useMediaQuery } from '@mui/material';
import Div from '@jumbo/shared/Div';
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import Logo from '../../../../shared/Logo';
import { SIDEBAR_STYLES, SIDEBAR_VARIANTS } from '@jumbo/utils/constants';
import useJumboHeaderTheme from '@jumbo/hooks/useJumboHeaderTheme';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';


const Header = () => {
  const { sidebarOptions, setSidebarOptions } = useJumboLayoutSidebar();
  const [dropdownSearchVisibility, setDropdownSearchVisibility] = React.useState(false);
  const { headerTheme } = useJumboHeaderTheme();
  const storeData = useSelector((state) => state?.store);
  const userData = useSelector((state) => state?.auth?.loggedUser);
  const showDropdownSearch = useMediaQuery('(max-width:575px)');
  const [storeId, setStoreId] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (storeData?.list && storeData.list.length > 0) {
      // Check if there's a saved store in localStorage
      const savedStoreId = localStorage.getItem('selectedStoreId');

      if (savedStoreId) {
        // Find the store with the saved ID
        const savedStore = storeData.list.find((store) => store._id === savedStoreId);
        if (savedStore) {
          setStoreId(savedStore._id);
          return;
        }
      }

      // If no saved store or saved store not found, use the default store
      const defaultStore = storeData.list.find((store) => store.isDefault === true);
      if (defaultStore) {
        setStoreId(defaultStore._id);
        localStorage.setItem('selectedStoreId', defaultStore._id);
      }
    }
  }, [storeData?.list]);

  const handleStoreChange = (event) => {
    const selectedId = event.target.value;
    setStoreId(selectedId);
    if (selectedId) {
      localStorage.setItem('selectedStoreId', selectedId);
    } else {
      localStorage.removeItem('selectedStoreId');
    }
    if (location.pathname === '/') {
      window.location.reload();
    } else {
      navigate('/');
    }
  };

  return (
    <React.Fragment>
      {(sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER ||
        sidebarOptions.variant === SIDEBAR_VARIANTS.TEMPORARY ||
        (sidebarOptions.variant === SIDEBAR_VARIANTS.PERSISTENT && !sidebarOptions.open)) && (
        <IconButton
          edge="start"
          color="inherit"
          aria-label="open drawer"
          sx={{
            ml: sidebarOptions.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER ? -2 : 0,
            mr: 3,
          }}
          onClick={() => setSidebarOptions({ open: !sidebarOptions.open })}>
          {sidebarOptions?.open ? <MenuOpenIcon /> : <MenuIcon />}
        </IconButton>
      )}
      {sidebarOptions?.style === SIDEBAR_STYLES.CLIPPED_UNDER_HEADER && (
        <Logo sx={{ mr: 3 }} mode={headerTheme.type ?? 'light'} />
      )}
      {showDropdownSearch && (
        <Slide in={dropdownSearchVisibility}>
          <Div
            sx={{
              zIndex: 5,
              left: 0,
              right: 0,
              position: 'absolute',
              height: '100%',
            }}>
            <IconButton
              sx={{
                position: 'absolute',
                right: 15,
                top: '50%',
                color: 'inherit',
                transform: 'translateY(-50%)',
              }}
              onClick={() => setDropdownSearchVisibility(false)}>
              <CloseIcon />
            </IconButton>
          </Div>
        </Slide>
      )}

      <Stack direction="row" alignItems="center" spacing={1.25} sx={{ ml: 'auto' }}>
        {userData?.roleType !== 1 ? (
          <Div sx={{ width: 150 }}>
            <FormControl size="small" fullWidth>
              <InputLabel id="store-select-label">Select a Store</InputLabel>
              <Select
                labelId="store-select-label"
                id="store-select"
                fullWidth
                value={storeId}
                label="Select a Store"
                onChange={handleStoreChange}>
                {storeData?.list?.map((store) => (
                  <MenuItem key={store._id} value={store._id}>
                    {store.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Div>
        ) : null}
        <AuthUserDropdown />
      </Stack>
    </React.Fragment>
  );
};

export default Header;
